'use client';

export function TypingIndicator() {
  return (
    <div className='mb-2 flex justify-start'>
      <div className='bg-card border-border/50 rounded-2xl rounded-bl-md border px-4 py-3 shadow-sm'>
        <div className='flex items-center gap-1'>
          <span className='bg-muted-foreground/60 h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s]' />
          <span className='bg-muted-foreground/60 h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s]' />
          <span className='bg-muted-foreground/60 h-2 w-2 animate-bounce rounded-full' />
        </div>
      </div>
    </div>
  );
}
